import api from '@/api';

const resource = 'externo/funcionarios';

export default {

  buscarFuncionarioAtivoPorNome(nome) {
    return api.get( `${resource}/nome`, {
      params: {
        nome,
      }
    } );
  }
};
